<template>
  <div>
    <div class="header">
      <span>地域趋势</span>
      <el-form :inline="true" class="header-right">
        <el-form-item>
          <el-cascader
            style="width: 150px"
            size="mini"
            @change="selectOrg"
            ref="cascader"
            @visible-change="orgChange"
            :props="{ checkStrictly: true, value: 'id', label: 'name', children: 'children' }"
            :options="orgs"
            v-model="orgIndex">
          </el-cascader>
        </el-form-item>
        <el-form-item>
          <el-radio-group v-model="dateRadio" size="mini" @change="dateRadioChange">
            <el-radio-button label="年"></el-radio-button>
            <el-radio-button label="月"></el-radio-button>
            <el-radio-button label="日"></el-radio-button>
          </el-radio-group>
        </el-form-item>
        <el-form-item>
          <el-date-picker
            style="width: 130px"
            v-model="start"
            :type="dateType"
            size="mini"
            placeholder="开始日期"
            @change="dateChange">
          </el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-date-picker
            style="width: 130px"
            v-model="end"
            :type="dateType"
            size="mini"
            placeholder="结束日期"
            @change="dateChange">
          </el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-select size="mini" style="width: 150px" @change="selectPostition"  v-model="province" placeholder="请选择">
            <el-option
              v-for="(item, i) in provinceList"
              :key="item.id"
              :label="item.name"
              :value="i">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-checkbox v-model="checked" :disabled="disabled" @change="loadData">同期对比</el-checkbox>
        </el-form-item>
      </el-form>
    </div>
    <el-tabs v-model="activeName" @tab-click="handleClick">
      <el-tab-pane label="总趋势" name="999">
        <eber-line ref="chart999" v-if="series.length > 0" :series="series" :xAxis="xAxis" :legend="legend"></eber-line>
        <div v-if="series.length === 0" style="height: 330px; text-align: center; padding-top: 20px;" >暂无数据</div>
      </el-tab-pane>
      <el-tab-pane label="门诊趋势" name="0">
        <eber-line ref="chart0" v-if="series.length > 0" :series="series" :xAxis="xAxis" :legend="legend"></eber-line>
        <div v-if="series.length === 0" style="height: 330px; text-align: center; padding-top: 20px;">暂无数据</div>
      </el-tab-pane>
      <el-tab-pane label="出院趋势" name="1">
        <eber-line ref="chart1" v-if="series.length > 0" :series="series" :xAxis="xAxis" :legend="legend"></eber-line>
        <div v-if="series.length === 0" style="height: 330px; text-align: center; padding-top: 20px;">暂无数据</div>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
  import _ from 'lodash'
  import moment from 'moment'
  import PositionService from '@/request/dictionary/position'
  import RecordCountService from '@/request/count/record'
  import EberLine from "./eber-line";
  export default {
    name: "CountPostitionTrend",
    components: {EberLine},
    props: {
      orgs: {
        type: Array,
        default() {
          return null
        }
      }
    },
    data() {
      return{
        start: moment().subtract(6, 'days').startOf('day').valueOf(), // 开始时间
        end: moment().endOf('day').valueOf(), // 结束时间
        dateRadio: '日',
        dateType: 'date',
        dataLine: [],
        provinceList: [], // 地址列表
        recordPositionList: [], // 当期地域趋势列表
        lastRecordPositionList: [], // 往期地域趋势列表
        oids: [], // 选中组织的所有科室id
        oid: 0, // 记录oid 以便和 selectOrgs的id 比较 是否进行重新查询数据
        selectOrgs: null,
        orgIndex: [], // 默认组织
        disabled: false,
        province: '',
        checked: false,
        formatType: null,
        activeName: '999',
        xAxis: [],
        series: [],
        legend: [],
      }
    },
    created() {
      this.init();
      this.loadProvince();
    },
    watch: {
      orgs() {
        this.init();
      },
      activeName (v) {
        this.$nextTick(() => {
          if (this.$refs[`chart${v}`]) {
            this.$refs[`chart${v}`].myChart.resize()
          }
        })
      }
    },
    methods: {
      init() {
        if (this.orgs.length > 0 ) {
          this.orgIndex = [this.orgs[0].id]
          let _oids = [];
          _.forEach(this.orgs[0].children, val => {
            _oids = _.concat(_oids, val.childrenIds || [])
          })
          this.oid = this.orgs[0].id
          this.oids = _oids;
          this.dateChange();
        }
      },
      // 当期
      loadData () {
        let type = 'day';
        if (this.dateType !== 'date') {
          type = this.dateType
        }
        const _hospitalized = _.clone(this.activeName);
        RecordCountService.countPosition({
          oids: _.join(this.oids) || null,
          level: 1,
          group: type,
          hospitalized: (_hospitalized === '999') ? null : _.toInteger(_hospitalized),
          start: moment(this.start).startOf(type).valueOf(),
          end: moment(this.end).endOf(type).valueOf(),
        }).then( res => {
          this.recordPositionList = res.result || [];
          this.loadLastData();
        })
      },
      // 往期
      loadLastData() {
        if (this.checked) {
          let type = 'day';
          if (this.dateType !== 'date') {
            type = this.dateType
          }
          const _hospitalized = _.clone(this.activeName);
          RecordCountService.countPosition({
            oids: _.join(this.oids) || null,
            level: 1,
            group: type,
            hospitalized: (_hospitalized === '999') ? null : _.toInteger(_hospitalized),
            start: moment(this.start).subtract(1, 'year').startOf(type).valueOf(),
            end: moment(this.end).subtract(1, 'year').endOf(type).valueOf(),
          }).then( res => {
            this.lastRecordPositionList = res.result || [];
            this.selectPostition(this.province);
          });
        } else {
          this.selectPostition(this.province);
        }
      },
      // 省级地址列表
      loadProvince() {
        PositionService.listProvince().then(res => {
          this.provinceList = res.result || [];
        })
      },
      selectOrg(index) {
        let orgs = _.cloneDeep(this.orgs);
        _.forEach(index, (val, i) => {
          let orgIndex = null;
          if (i === 0) {
            orgIndex = _.findIndex(orgs, {id: val});
            orgs = orgs[orgIndex];
          } else {
            orgIndex = _.findIndex(orgs.children, {id: val});
            orgs = orgs.children[orgIndex];
          }
        });
        this.selectOrgs = orgs
      },
      orgChange (hide) {
        if (!hide && this.selectOrgs) {
          const _orgid = this.selectOrgs.id;
          if (this.oid !== _orgid) {
            this.oid = _orgid;
            let _oids = []
            if (this.selectOrgs.typeId === 1) {
              _.forEach(this.selectOrgs.children, val => {
                _oids = _.concat(_oids, val.childrenIds || val.id)
              })
            } else {
              _oids = this.selectOrgs.childrenIds || this.selectOrgs.id
            }
            this.oids = _oids
            this.loadData()
          }
        } else {
          this.$nextTick(() => {
            const lis = this.$refs.cascader.panel.$el.lastChild.querySelectorAll('li')
            _.forEach(lis, val => {
              if (val.className.indexOf('is-active') !== -1) {
                val.click()
              }
            })
          })
        }
      },
      // 选择地址 拼接series
      selectPostition(i) {
        if (!i && this.recordPositionList.length > 0) {
          i = _.findIndex(this.provinceList, {sn: this.recordPositionList[0].positionsn});
          if (i !== -1) {
            this.province = i
          }
        }
        if (i) {
          this.series = [];
          this.legend = [];
          const positionList =  _.clone(this.recordPositionList || []);
          const _xAxis = this.xAxis || [];
          const psn = this.provinceList[i].sn || 33;
          const yline = _.clone(this.dataLine);
          const serie = {name: '当期',type: 'line', lineStyle:{color: '#61A5E8'}, itemStyle:{color: '#61A5E8'}, data: []};
          let recordProvinceList = {count: {}};
          const index = _.findIndex(positionList, {positionsn: psn});
          if (index !== -1) {
            recordProvinceList =positionList[index];
          }
          _.forEach(_xAxis, (val, i) => {
            if (recordProvinceList.count[val]) {
              yline[i] = recordProvinceList.count[val]
            }
          });
          serie.data = yline;
          if (yline.toString() !== this.dataLine.toString()) {
            this.series.push(serie);
            this.legend.push('当期');
          }
          const lastPositionList =  _.clone(this.lastRecordPositionList || []);
          if (this.checked && this.lastRecordPositionList.length > 0) {
            const lastyline = _.clone(this.dataLine);
            let lastSerie = {name: '往期', type: 'line', lineStyle:{color: '#7ECF51'}, itemStyle:{color: '#7ECF51'}, data: []};
            const lastIndex = _.findIndex(lastPositionList, {positionsn: psn});
            let lastRecordProvinceList = {count: {}};
            if (lastIndex !== -1) {
              lastRecordProvinceList =lastPositionList[lastIndex];
            }
            _.forEach(_xAxis, (val, i) => {
              const dateType = moment(val).subtract(1, 'year').format(this.formatType);
              if (lastRecordProvinceList.count[dateType]) {
                lastyline[i] = lastRecordProvinceList.count[dateType]
              }
            });
            if (lastyline.toString() !== this.dataLine.toString()) {
              lastSerie.data = lastyline;
              this.series.push(lastSerie);
              this.series.push('往期');
            } else {
              this.$message.error('暂无同期对比数据!');
            }
          }
        }
      },
      dateRadioChange(event) {
        switch (event) {
          case '年':
            this.dateType = 'year';
            this.start = moment().subtract(4, 'year').startOf('year').valueOf(); // 开始时间
            this.end =  moment().endOf('year').valueOf(); // 结束时间
            break;
          case '月':
            this.dateType = 'month';
            this.start = moment().subtract(12, 'month').startOf('month').valueOf(); // 开始时间
            this.end =  moment().endOf('month').valueOf(); // 结束时间
            break;
          default:
            this.dateType = 'date';
            this.start = moment().subtract(6, 'days').startOf('day').valueOf(); // 开始时间
            this.end =  moment().endOf('day').valueOf(); // 结束时间
        }
        this.dateChange();
      },
      // 时间改变 根据时间生成x轴 和serise data的数组长度
      dateChange() {
        if (!this.start || !this.end) {
          this.$message({
            message: '开始时间或结束时间不能为空',
            type: 'warning'
          });
          return
        }
        if (this.start > this.end) {
          this.$message({
            message: '开始时间不能大于结束时间',
            type: 'warning'
          });
        }
        const timeLine = [];
        const _dataLine = [];
        let type = 'day';
        this.formatType = 'YYYY-M-D';
        if (this.dateType !== 'date') {
          type = this.dateType
        }
        if (this.dateType === 'year') {
          this.formatType = 'YYYY';
        }
        if (this.dateType === 'month') {
          this.formatType = 'YYYY-M';
        }
        const num = moment(this.end).diff(moment(this.start), type);
        switch(type) {
          case 'day':
            this.disabled = num > 365
            break;
          case 'month':
            this.disabled = num > 12
            break;
          case 'year':
            this.disabled = num > 1
            break;
          default:
            this.disabled = true
        }
        if (this.disabled) {
          this.checked = false;
        }
        for (let i = num; i >= 0; i --) {
          const date = moment(this.end).subtract(i, type).format(this.formatType);
          timeLine.push(date);
          _dataLine.push(0);
        }
        this.xAxis = timeLine;
        this.dataLine = _dataLine;
        this.loadData();
      },
      handleClick() {
        this.loadData();
      }
    }
  }
</script>

<style scoped>
  .header {
    height: 50px;
    line-height: 48px;
    color: #000;
    border-bottom: 1px solid #ebeef5;
    font-size: 20px;
    font-weight: 500;
    margin-bottom: 20px;
    position: relative;
  }
  .header-right{
    z-index: 999;
    float: right;
    position: absolute;
    right: 0;
    top: 4px;
  }
</style>
